import { PLATFORMS, getMarketBalanceQueryKey } from '@/lib/wallets/registry'
import type { BridgePlatform } from '@/lib/wallets/types'
import type { QueryClient } from '@tanstack/react-query'

export function invalidateMarketBalances(
	queryClient: QueryClient,
	platforms: readonly BridgePlatform[] = PLATFORMS
) {
	for (const platform of platforms) {
		queryClient.invalidateQueries({
			queryKey: getMarketBalanceQueryKey(platform, undefined).slice(0, 2),
		})
	}
}
